import React, { useCallback, useEffect } from "react";
import { StyledForgotPasswordForm } from "./index.styled";
import { Form, Input } from "antd";
import ContainerButton from "_lib/ContainerButton";
import { useCustomerManagementStore } from "_hooks";
import PropTypes from "prop-types";

const ForgotPasswordEmailStep = (props) => {
  const { next, setEmail } = props;

  const {
    customerManagement: { initiateForgotPasswordStatus },
    initiateForgotPassword,
    clearInitiateForgotPasswordStatus,
  } = useCustomerManagementStore();

  useEffect(() => {
    if (initiateForgotPasswordStatus === "success") {
      clearInitiateForgotPasswordStatus();
      next();
    }
  }, [clearInitiateForgotPasswordStatus, initiateForgotPasswordStatus, next]);

  const onFinish = useCallback(
    (values) => {
      setEmail(values?.email);
      initiateForgotPassword(values);
    },
    [initiateForgotPassword, setEmail]
  );

  const loading = initiateForgotPasswordStatus === "loading";
  return (
    <StyledForgotPasswordForm onFinish={onFinish}>
      <Form.Item
        name="email"
        rules={[
          {
            required: true,
            message: "Please input your email!",
          },
        ]}
      >
        <Input placeholder="Email" size="large" />
      </Form.Item>

      <ContainerButton
        size="large"
        title="Send"
        type="primary"
        fullWidth
        htmlType="submit"
        loading={loading}
      />
    </StyledForgotPasswordForm>
  );
};

ForgotPasswordEmailStep.propTypes = {
  next: PropTypes.func.isRequired,
  setEmail: PropTypes.func.isRequired,
};

export default ForgotPasswordEmailStep;
